/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SurveySection,
    SurveySectionFromJSON,
    SurveySectionFromJSONTyped,
    SurveySectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SurveyResponse
 */
export interface SurveyResponse {
    /**
     * 
     * @type {SurveySection}
     * @memberof SurveyResponse
     */
    nextSection?: SurveySection;
}

export function SurveyResponseFromJSON(json: any): SurveyResponse {
    return SurveyResponseFromJSONTyped(json, false);
}

export function SurveyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextSection': !exists(json, 'next-section') ? undefined : SurveySectionFromJSON(json['next-section']),
    };
}

export function SurveyResponseToJSON(value?: SurveyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'next-section': SurveySectionToJSON(value.nextSection),
    };
}


